import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { CommonService } from './common.service';
import { HttpHeaders } from '@angular/common/http';
import { BindingFlags } from '@angular/compiler/src/core';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { CacheService } from './cache.service';
import { TranslateService } from '@ngx-translate/core';
import { DIMBO_CONSTANT } from './../utils/constant';
import { error } from 'protractor';
import localeNb from '@angular/common/locales/nb';
import { registerLocaleData } from '@angular/common';
registerLocaleData(localeNb, 'nb');

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {

  constructor(
    private router: Router,
    private cacheService: CacheService,
    private translationService: TranslateService,
    private toastrService: ToastrService,
    private commonService: CommonService) { }

  // Method to handle to athentication failure of the user
  public unauthenticateUser() {
    //this.isValidUser = false;
    //this.isValidRole = false
    this.cacheService.clear();
    //this.dialogRef.closeAll();
    this.router.navigate(['/']);
    //this.translationService.loadTranlationForLocale(DPO_CONSTANT.DEFAULT_LOCALE);
  }



  // Method to handle the activation of the routes
  async validateToken(token: string): Promise<Observable<boolean>> {
    let flag: boolean;

    if (token) {
      // Authenticate the User based on token
      let isUserValid = <boolean>await this.authenticateByToken(token);
      flag = isUserValid;
      //  console.log('Observable finished!!--->', isUserValid);
    } else {
      this.unauthenticateUser();
      flag = false;
    }
    //return flag;
    return of(flag);
  }


  // Method to call the authentication API based on Token
  private authenticateByToken(token: string): Promise<boolean> {
    let flag: boolean = false;
    return new Promise(resolver => {
      setTimeout(() => {
        // Call Decode API
        this.commonService.authenticateToken(token).subscribe(response => {
          if (response) {
            var n = sessionStorage.length;
            while (n--) {
              var key = sessionStorage.key(n);

              sessionStorage.removeItem(key);

            }
            flag = true;
            this.cacheService.setItem(DIMBO_CONSTANT.CACHE_JWT_TOKEN, token);
            this.cacheService.setItem(DIMBO_CONSTANT.CACHE_JWT_TOKEN_RESPONSE, response);
            this.cacheService.setItem(DIMBO_CONSTANT.CACHE_JWT_VIN, response['vin']);
            this.cacheService.setItem(DIMBO_CONSTANT.CACHE_JWT_SOURCE_APPLICATION, response['sourceApplication']);
            this.cacheService.setItem(DIMBO_CONSTANT.CACHE_JWT_LANGUAGE_RAW, this.getLanguage(response['locale']));
            this.cacheService.setItem(DIMBO_CONSTANT.CACHE_JWT_LANGUAGE, this.getLanguage(response['locale']));
            let country = !response['repairerCountry'] ? response['userCountry'] : response['repairerCountry'];
            this.cacheService.setItem(DIMBO_CONSTANT.CACHE_JWT_REPAIRER_COUNTRY, country);
            let email = !response['customerEmail'] ? null : response['customerEmail'];
            this.cacheService.setItem(DIMBO_CONSTANT.CACHE_JWT_CUSTOMER_EMAIL, email);
            this.cacheService.setItem(DIMBO_CONSTANT.CACHE_JWT_CUSTOMER_LAST_NAME, response['customerLastName']);
            this.cacheService.setItem(DIMBO_CONSTANT.CACHE_JWT_REPAIRER_NAME, response['repairerName']);
            this.cacheService.setItem(DIMBO_CONSTANT.CACHE_JWT_REPAIRER_CITY, response['repairerCity']);
            this.cacheService.setItem(DIMBO_CONSTANT.CACHE_JWT_REPAIRER_ADDRESS, response['repairerAddress']);
            this.cacheService.setItem(DIMBO_CONSTANT.CACHE_JWT_REPAIRER_ZIP, response['repairerZip']);
            let milage = !response['mileage'] ? 0 : response['mileage'];
            this.cacheService.setItem(DIMBO_CONSTANT.CACHE_JWT_MILEAGE, milage);
            let unit = !response['mileageUnit'] ? null : response['mileageUnit'];
            this.cacheService.setItem(DIMBO_CONSTANT.CACHE_JWT_MILEAGE_UNIT, unit);

            let vehifocheck = this.cacheService.getItem(DIMBO_CONSTANT.EDIT_VEHICLE_INFO_CHECK);
            if (vehifocheck != 'true') {
              this.cacheService.setItem(DIMBO_CONSTANT.EDIT_VEHICLE_INFO_CHECK, 'false');
            }

            this.cacheService.setItem(DIMBO_CONSTANT.CACHE_JWT_USER_ID, response['userID']);
            this.cacheService.setItem(DIMBO_CONSTANT.CACHE_JWT_POS, response['pos']);
            this.cacheService.setItem(DIMBO_CONSTANT.CACHE_JWT_RRDI, response['rrdi']);
            this.cacheService.setItem(DIMBO_CONSTANT.CACHE_JWT_PHYSICAL_SITE, response['physicalSite']);
            
            let sourceApplication = response['sourceApplication'].toUpperCase();
            if (((sourceApplication === 'HUB') && (!response['rrdi'] && !response['physicalSite'])) ||
                ((sourceApplication === 'LINK' || sourceApplication === 'TI') && (!response['rrdi'] && !response['pos'] && !response['physicalSite']))) {
              this.cacheService.setItem(DIMBO_CONSTANT.CACHE_IS_CENTRAL_USER, true);
            } else {
              this.cacheService.setItem(DIMBO_CONSTANT.CACHE_IS_CENTRAL_USER, false);
            }

            if ((sourceApplication === 'POI' || sourceApplication === 'ERCS') && (response['readOnly'] === 'ro')) {
              this.cacheService.setItem(DIMBO_CONSTANT.CACHE_IS_ADMIN_USER, true);
            } else {
              this.cacheService.setItem(DIMBO_CONSTANT.CACHE_IS_ADMIN_USER, false);
            }

            if (this.cacheService.getItem(DIMBO_CONSTANT.CACHE_IS_ADMIN_USER) || this.cacheService.getItem(DIMBO_CONSTANT.CACHE_IS_CENTRAL_USER)) {
              this.cacheService.setItem(DIMBO_CONSTANT.CACHE_IS_READ_ONLY, true);
            } else {
              this.cacheService.setItem(DIMBO_CONSTANT.CACHE_IS_READ_ONLY, false);
            }
            if (this.cacheService.getItem(DIMBO_CONSTANT.CACHE_CUSTOMER_VERIFICATION_RETRY_COUNT) >= 0 && this.cacheService.getItem(DIMBO_CONSTANT.CACHE_CUSTOMER_VERIFICATION_RETRY_COUNT) < 5) {
              this.cacheService.setItem(DIMBO_CONSTANT.CACHE_CUSTOMER_VERIFICATION_RETRY_COUNT, this.cacheService.getItem(DIMBO_CONSTANT.CACHE_CUSTOMER_VERIFICATION_RETRY_COUNT));
            } else {
              this.cacheService.setItem(DIMBO_CONSTANT.CACHE_CUSTOMER_VERIFICATION_RETRY_COUNT, 5);
            }
            this.cacheService.setItem(DIMBO_CONSTANT.CACHE_LANGUAGE_LOCAL,response['locale']);
            this.cacheService.setItem(DIMBO_CONSTANT.CACHE_IS_MP_CALL_FIRST_TIME, true);
            this.cacheService.setItem(DIMBO_CONSTANT.CACHE_IS_MP_SEVERE_HAS_DATA, false);
            this.cacheService.setItem(DIMBO_CONSTANT.CACHE_IS_CUSTOMER_VERIFIED, false);

            if (sourceApplication === 'LINK' || sourceApplication === 'TI') {
              // temporary FCA brand to request correct service
              this.cacheService.setItem(DIMBO_CONSTANT.CACHE_BRAND, DIMBO_CONSTANT.FCA_BRANDS[0]);
              // disable customer challenge
              this.cacheService.setItem(DIMBO_CONSTANT.CACHE_IS_CUSTOMER_VERIFIED, true);
            }

            //DMBR-36: Added companyName
            if (response['companyName'] === undefined) {

            }
            else {
              this.cacheService.setItem(DIMBO_CONSTANT.CACHE_JWT_REPAIRER_NAME, response['companyName']);
            }

            //DMBR-36: End of companyName
          }
          return resolver(flag);
        }, error => {
          if (error && error.status && (error.status === 400 || error.status === 401 || error.status === 403 || error.status === 503) && error.error) {
            this.toastrService.warning(this.translationService.instant(error.error.message), this.translationService.instant('dimbo.i18n.message.token.invalid'), { disableTimeOut: true });
          } else {
            this.toastrService.error(this.translationService.instant(error.error.message), this.translationService.instant('dimbo.i18n.message.token.invalid'), { disableTimeOut: true });
          }
          this.unauthenticateUser();
        });
      }, 500);
    });
  }

  //DMBR-47 : Modify method for "no-NO" language - took 'nb' instead of 'no' as per new i18 guideline.
  public getLanguage(language: string) {
    if (language.length > 2) {
      const languageAr = language.split('-');
      if (languageAr[0] === 'no') {
        languageAr[0] = 'nb';
      }     
       return languageAr[0];
    } else {
      return language;
    }
  } 
}
